export default function GlobalStyles({ extra = "" }) {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800;900&display=swap');

      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      html { scroll-behavior: smooth; }
      body { font-family: 'Sora', -apple-system, sans-serif; background: #fff; color: #0F172A; overflow-x: hidden; }

      @keyframes fadeIn  { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:none; } }
      @keyframes float   { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-10px); } }
      @keyframes pulse   { 0%,100% { opacity:1; } 50% { opacity:.4; } }
      @keyframes blink   { 0%,100% { opacity:1; } 50% { opacity:0; } }
      @keyframes marquee { from { transform:translateX(0); } to { transform:translateX(-50%); } }
      @keyframes spin    { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

      .hero-grid       { display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; }
      .about-grid      { display:grid; grid-template-columns:1fr 1fr; gap:72px; align-items:center; }
      .footer-grid     { display:grid; grid-template-columns:2fr 1fr 1fr 1fr; gap:48px; }
      .process-grid    { display:grid; grid-template-columns:repeat(5,1fr); gap:0; position:relative; }
      .nav-links       { display:flex; align-items:center; gap:4px; }
      .nav-cta         { display:flex !important; }
      .mob-menu-btn    { display:none; }
      .nav-logo-img    { height:52px; width:auto; object-fit:contain; display:block; }

      .contact-grid {
        display: grid;
        grid-template-columns: 1fr 1.35fr;
        align-items: stretch;
        background: #fff;
        border-radius: 24px;
        box-shadow: 0 16px 48px rgba(0,0,0,.06);
        border: 1px solid #E5E7EB;
        overflow: hidden;
      }
      .info-panel { padding: 48px 44px; }
      .form-panel { padding: 48px 52px; }
      .form-row   { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

      .page-main { padding-top: 0; min-height: 50vh; }

      @media (max-width:1100px) {
        .hero-grid     { grid-template-columns:1fr 1fr; gap:36px; }
        .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
        .process-grid  { grid-template-columns:repeat(3,1fr); gap:24px; }
        .hero-float-left  { left: 0 !important; }
        .hero-float-right { right: 0 !important; }
      }

      @media (max-width:900px) {
        .hero-grid     { grid-template-columns:1fr; gap:48px; }
        .about-grid    { grid-template-columns:1fr; gap:36px; }
        .contact-grid  { grid-template-columns:1fr; }
        .form-row      { grid-template-columns:1fr; }
        .form-panel    { padding: 40px 32px; }
        .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
        .process-grid  { grid-template-columns:repeat(2,1fr); gap:24px; }
        .nav-links     { display:none !important; }
        .nav-cta       { display:none !important; }
        .mob-menu-btn  { display:flex !important; align-items:center; justify-content:center; }
        .float-card-tech { left: 0 !important; right:auto; bottom:-10px !important; min-width:190px !important; }
        .hero-svg-wrap img { height: auto !important; max-height: 340px !important; }
        .section-pad { padding-left:20px !important; padding-right:20px !important; }
        .cta-section { margin:0 16px 48px !important; padding:48px 24px !important; }
        .process-line { display:none !important; }
      }

      @media (max-width:640px) {
        .hero-grid     { grid-template-columns:1fr; gap:36px; }
        .footer-grid   { grid-template-columns:1fr; }
        .process-grid  { grid-template-columns:1fr 1fr; gap:20px; }
        .float-card-tech { display:none !important; }
        .info-panel    { padding: 36px 24px; }
        .form-panel    { padding: 36px 24px; }
        .hero-svg-wrap img { max-height: 220px !important; }
        .hero-float-left  { left:4px !important; top:auto !important; bottom:-8px !important; min-width:160px !important; padding: 10px 12px !important; }
        .hero-float-right { right:4px !important; top:8px !important; padding: 10px 14px !important; }
        .hero-float-br    { display:none !important; }
        .section-pad { padding-left:16px !important; padding-right:16px !important; }
        .cta-section { margin:0 12px 40px !important; padding:40px 20px !important; }
        section:not(#contact) { padding-left: 16px !important; padding-right: 16px !important; }
        footer  { padding-left: 16px !important; padding-right: 16px !important; }
        .about-grid > div:first-child { display:none; }
        nav .nav-bar-inner { padding: 0 16px !important; }
        nav .nav-top-bar { padding: 6px 16px !important; }
        .hero-grid.section-pad { padding: 0 16px 60px !important; }
        .nav-logo-img { height: 40px !important; }
      }

      @media (max-width:500px) {
        .topbar-right { display:none !important; }
        .footer-bottom { flex-direction:column !important; text-align:center; gap:6px; }
      }

      @media (max-width:400px) {
        .process-grid { grid-template-columns:1fr; }
        .hero-float-left, .hero-float-right { display:none !important; }
      }

      @media (max-width:480px) {
        .footer-grid { grid-template-columns: 1fr !important; gap: 28px; }
        section#services > div > div:last-child { grid-template-columns: 1fr !important; }
      }

      /* Service / solution page grids */
      [class$="-hero-grid"] { display:grid; grid-template-columns:1fr 1fr; gap:64px; align-items:center; }
      [class$="-stats-grid"] { display:grid; grid-template-columns:repeat(4,1fr); gap:32px; }
      [class$="-cs-grid"] { display:grid; grid-template-columns:1fr 1fr; gap:52px; align-items:center; }
      [class$="-form-row"] { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
      .featured-project-grid { display:grid; grid-template-columns:1fr 1fr; gap:56px; align-items:center; }
      .blog-layout { display:grid; grid-template-columns:2.2fr 1fr; gap:60px; align-items:start; }

      @media (max-width:1100px) {
        [class$="-stats-grid"] { grid-template-columns:repeat(2,1fr); }
      }
      @media (max-width:900px) {
        [class$="-hero-grid"] { grid-template-columns:1fr; gap:48px; }
        [class$="-cs-grid"] { grid-template-columns:1fr !important; gap:36px !important; }
        .blog-layout { grid-template-columns:1fr; gap:48px; }
        .featured-project-grid { grid-template-columns:1fr; gap:36px; }
        [class$="-section"] { padding-left:20px !important; padding-right:20px !important; }
      }
      @media (max-width:640px) {
        [class$="-stats-grid"] { grid-template-columns:repeat(2,1fr); gap:24px; }
        [class$="-form-row"] { grid-template-columns:1fr !important; }
        [class$="-section"] { padding-left:16px !important; padding-right:16px !important; }
      }

      ${extra}
    `}</style>
  );
}
